// @flow @jsx h

import BaseVideo from '@nrk/dh-video-component'
import { Component, h } from 'preact'
import style from './index.css'
import Scrubber from './Scrubber'
import TogglePlayButton from './TogglePlayButton'
import MuteButton from './MuteButton'

type Caption = {
  in: string,
  out: string,
  text: string
}

type Source = {
  type: string,
  src: string
}

type Props = {
  type: 'video',
  value: {
    captions?: Caption[],
    sources?: Source[],
    poster?: string,
    id: string
  },
  mediaBaseUrl: string,
  muted: boolean,
  onAnalyticsEvent: Function,
  onRegisterTriggerElement: Function,
  onToggleMute: Function,
  visible: boolean,
  intersectionRatio: number,
  isIntersecting: boolean,
  style?: Object
}

type State = {
  caption: string | null,
  // muted: boolean,
  time: number,
  duration: number,
  paused: boolean,
  userPaused: boolean
}

class Video extends Component<Props, State> {
  elm: HTMLDivElement
  video: BaseVideo

  constructor () {
    super()

    this.state = {
      paused: true,
      caption: null,
      muted: true,
      time: 0,
      duration: 0,
      userPaused: false
    }
  }

  componentDidMount () {
    this.props.onRegisterTriggerElement(this.elm)
  }

  handleCaptionCueEnter = (cue: any) => {
    this.setState({ caption: cue.text })
  }

  handleCaptionCueExit = () => {
    this.setState({ caption: null })
  }

  handleDurationChange = (event: Object) => {
    this.setState({ duration: event.target.duration })
  }

  handleTimeUpdate = (event: Object) => {
    this.setState({ time: event.target.currentTime })
  }

  handlePositionUpdate = (position: number) => {
    this.video.updateTime(position * this.state.duration)
  }

  handleTogglePlay = () => {
    const paused = !this.state.paused
    this.setState({ paused, userPaused: paused })
    if (!paused) {
      this.video.play()
    }
  }

  // handleToggleMute = () => {
  //   this.setState({ muted: !this.state.muted })
  // }

  handlePlay = () => {
    this.setState({ paused: false })
    this.props.onAnalyticsEvent({
      action: `video/PLAY/${this.props.value.id}`
    })
  }

  handlePause = () => {
    this.setState({ paused: true })
    this.props.onAnalyticsEvent({
      action: `video/PAUSE/${this.props.value.id}`
    })
  }

  handleEnded = () => {
    this.setState({ paused: true })
  }

  render () {
    const { intersectionRatio, mediaBaseUrl, muted, onToggleMute } = this.props
    const { caption, duration, time, paused, userPaused } = this.state
    const { captions, poster, sources } = this.props.value
    const playing = !userPaused && intersectionRatio > 0.75

    return (
      <div
        ref={elm => (this.elm = elm)}
        className={style.video}
        style={this.props.style}
      >
        <div className={style.video__videoWrapper}>
          {sources && (
            <BaseVideo
              ref={video => (this.video = video)}
              preload='auto'
              muted={muted}
              playing={playing}
              captions={captions}
              poster={poster ? `${mediaBaseUrl}${poster}` : null}
              sources={sources.map(source => {
                return { ...source, src: `${mediaBaseUrl}${source.src}` }
              })}
              onCaptionCueEnter={this.handleCaptionCueEnter}
              onCaptionCueExit={this.handleCaptionCueExit}
              onDurationChange={this.handleDurationChange}
              onPlay={this.handlePlay}
              onPause={this.handlePause}
              onEnded={this.handleEnded}
              onTimeUpdate={this.handleTimeUpdate}
            />
          )}
          <TogglePlayButton
            className={style.video__togglePlayButton}
            onClick={this.handleTogglePlay}
            paused={paused}
          />
          <Scrubber
            time={time}
            duration={duration}
            onPositionUpdate={this.handlePositionUpdate}
          />
          <MuteButton
            className={style.video__muteButton}
            onClick={onToggleMute}
            muted={muted}
          />
          {caption && (
            <div className={style.video__captionContainer}>
              <div
                className={style.video__caption}
                dangerouslySetInnerHTML={{ __html: caption }}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Video



// WEBPACK FOOTER //
// ./src/lib/@nrk/dh-feature-components/Video/index.js